import { Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import styles from "../../style.module.scss";

const FormTextField = ({
    name, control, errors, label = "", placeholder = "", required = false,
    disabled = false, inputCentered = false
}) => {
    const rules = required
        ? { required: "Поле обязательно для заполнения" }
        : undefined;
    const error = errors?.[name];

    return (
        <div className={`p-d-flex p-flex-column ${styles.formFieldContainer}`}>
            {label !== "" && <label className={required ? styles.requiredLabel : ""} htmlFor={name}>{label}</label>}
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({ field }) => {
                    const hasValue = field != null && field.value !== "";

                    return (
                        <div className={styles.inputWithClear}>
                            <InputText
                                id={name}
                                disabled={disabled}
                                className={`${error ? "p-invalid" : ""} ${
                                    inputCentered ? styles.centeredInput : ""
                                }`}
                                placeholder={placeholder}
                                {...field}
                            />
                            {hasValue && !disabled && (
                                <button
                                    type="button"
                                    className={styles.clearButton}
                                    onClick={() => field.onChange("")}
                                    aria-label="Очистить поле"
                                >
                                    <i className="pi pi-times"></i>
                                </button>
                            )}
                        </div>
                    );
                }}
            />
            {error && <small className="p-error">{error.message}</small>}
        </div>
    );
};

export default FormTextField;